var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "LanguageSwicther" }, [
    _vm.currentLocale
      ? _c(
          "ul",
          _vm._l(_vm.locales, function(locale, i) {
            return _c(
              "li",
              {
                key: i,
                class: { active: locale === _vm.currentLocale },
                on: {
                  click: function($event) {
                    return _vm.setLocale(locale)
                  }
                }
              },
              [_vm._v(" " + _vm._s(locale.toUpperCase()) + " ")]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }